module.exports = __webpack_public_path__ + "img/fi.88a671ba.svg";